export default "__VITE_ASSET__BSYhhDSA__"